"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var TablesQueryGql_1 = require("../../queries/TablesQueryGql");
var TablesDisplayGrid_1 = require("../sharedDisplayGrid/TablesDisplayGrid");
var TableRowDataFunctions_1 = require("../table/functions/TableRowDataFunctions");
function selectConnectionListResult(resultData) {
    return resultData && resultData.databaseTablesConnection;
}
exports.selectConnectionListResult = selectConnectionListResult;
function selectConnectionListResultWithTagFilter(resultData) {
    return resultData && resultData.tags && resultData.tags[0].databaseTablesConnection;
}
exports.selectConnectionListResultWithTagFilter = selectConnectionListResultWithTagFilter;
// This component is used only from the example. In the actual app, we render the Tables Explorer via VizPortal's "Explorer" instead,
// using these result mappers and the columns from the TablesDisplayGrid.
function TablesExplorerQueryGrid(props) {
    return (React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: TablesQueryGql_1.TablesQueryGql, partialQueryVariables: {
            orderBy: props.orderBy
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: TableRowDataFunctions_1.getRowDataWithMaxCountsForTable }, function (_a) {
        var rowStore = _a.rowStore;
        return (React.createElement(TablesDisplayGrid_1.TablesDisplayGrid, { rowStore: rowStore, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
    }));
}
exports.TablesExplorerQueryGrid = TablesExplorerQueryGrid;
//# sourceMappingURL=TablesExplorerQueryGrid.js.map